export default {
  list: {
    searchPlaceholder: 'Search Address',
    addAddress: 'Add Address',
    dataNotFound: 'Sorry, data not found!'
  },
  add: {
    title: 'Add Sender Location',
    addressLabel: 'Label',
    addressLabelPlaceholder: 'Ex: House, Office',
    senderName: 'Sender Name',
    senderNamePlaceholder: 'Please input sender name',
    phone: 'Phone Number',
    phonePlaceholder: 'Please input phone number',
    selectIcon: 'Select Icon',
    searchAddress: 'Village / District',
    searchAddressPlaceholder: 'Search Village / District',
    mapLocation: 'Map Location',
    searchLocation: 'Search location...',
    address: 'Address',
    addressPlaceholder: 'Please input address',
    detailAddress: 'Detail / Address Benchmark',
    detailAddressPlaceholder: 'Please input detail address',
    mainAddress: 'Set as main address',
    cancel: 'Cancel',
    save: 'Save',
    dataNotFound: 'Sorry, data not found!',
    loading: 'Loading...',
    selectLocation: 'Select Location',
    coordinates: 'Coordinates',
    delete: 'Delete',
    update: 'Update',
    confirmation: 'Confirmation',
    confirmUpdate: 'Are you sure you want to save changes to this address data?',
    confirmDelete: 'The address data to be deleted will be removed and cannot be undone.',
    no: 'No',
    yes: 'Yes',
    toast: {
      deleteSuccess: 'Address Successfully Deleted',
      dataSaved: 'Data has been saved',
      locationSelected: 'Location Selected',
      locationFailed: 'Failed to Load Location',
      tryAgain: 'Please try again',
      updateSuccess: 'Address Successfully Updated',
      addSuccess: 'Address Successfully Added'
    }
  }
}
